import './api/LastVisitedAPI.js';
import './api/LearningContentAPI.js';
import './api/LearningDataAPI.js';
import './api/chancenKurveAPI.js';
import './api/exportLearningData.js';
import './api/levumiAPI.js';
import './entities/CampusEvent.js';
import './entities/CampusEventFilter.js';
import './entities/CampusExercise.js';
import './entities/CampusLastVisited.js';
import './entities/CampusLesson.js';
import './entities/CampusSection.js';
import './entities/CampusSectionFilter.js';
import './entities/ChancenkurveConfig.js';
import './entities/ChancenkurveLevelOverride.js';
import './entities/ChancenkurveRecommendation.js';
import './entities/levumi/CampusLevumiItemGerman.js';
import './entities/levumi/CampusLevumiItemMath.js';
import './entities/levumi/CampusLevumiItemNumberDictation.js';
import './entities/levumi/CampusLevumiLevel.js';
import './entities/levumi/LevumiItemFilter.js';
